import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../../helpers/genericFormator';

export default function DateFormatter(props) {
  const { type, data } = props;
  return (
    data && (
      <div>
        {formatDate(data, type === 'date' ? 'DD MMM, YYYY, ' : 'DD MMM, YYYY')}
        {type === 'date' && <span>{formatDate(data, 'h:mm a')}</span>}
      </div>
    )
  );
}
DateFormatter.propTypes = {
  type: PropTypes.string,
  data: PropTypes.string,
};
DateFormatter.defaultProps = {
  type: '',
  data: '',
};
